import {FormattedMessage} from 'react-intl';

import {createElement, Component, PropTypes} from 'rlink-react';
import getAgeFromCookie from 'rlink-agegate/getAgeFromCookie';
import ageGateConfig from 'rlink-agegate/ageGateConfig';
import QueryString from 'rlink-querystring';
import themeable from 'rlink-theme/themeable';

import AgeGateForm from './AgeGateForm';
import AgeGateLockout from './AgeGateLockout';

const VALID_REDIRECTS = /^https?:\/\/[a-z0-9]+\.(dawnofwar|companyofheroes|relic)\.com(\/|$)/;

/**
 * Agegate component. Either shows the user a form to enter their
 * birth day or a message informing them that they do not meet the
 * criteria for viewing this content.
 *
 * The onDisable function prop should take care to remove this
 * component from the page it is displayed on. If the onDisable prop
 * does not remove this component it will show the user an error
 * message.
 */
export default class AgeGate extends Component {
  constructor (...args) {
    super(...args);

    this.state = {
      age: getAgeFromCookie(),
    };
  }

  onAgeSpecified () {
    const age = getAgeFromCookie();

    if (age >= ageGateConfig.minimumAge) {
      const params = new QueryString(window.location.search).toValuesDict();

      if ('agegate_redirect' in params
          && VALID_REDIRECTS.test(params.agegate_redirect)) {
        window.location.replace(params.agegate_redirect);
      } else {
        this.props.onDisable();
      }
    } else {
      // We should only need to set the age at this point because of
      // the other possibilities this is the only situation that
      // actually shows the age gate at all. The redirect moves away
      // from the current page and onDisable will remove the age gate.
      this.setState({age});
    }
  }

  innerComponent () {
    if (this.state.age === undefined) {
      return (
        <AgeGateForm
          selectedDay={this.props.selectedDay}
          selectedMonth={this.props.selectedMonth}
          selectedYear={this.props.selectedYear}
          submitLabel={this.props.submitLabel}
          prompt={this.props.prompt}
          {...AgeGateForm.theme({
            theme: this.props.theme,
            childThemes: this.props.childThemes,
          })}
          onSubmit={() => this.onAgeSpecified()} />
      );
    } else if (this.state.age < ageGateConfig.minimumAge) {
      return (
        <AgeGateLockout
          {...AgeGateLockout.theme({
            theme: this.props.theme,
            childThemes: this.props.childThemes,
          })} />
      );
    } else {
      // This case shouldn't ever happen because it should be handled
      // by critical.js and the implementation of onDisable. This
      // doesn't mean it won't though.
      return (
        <FormattedMessage
          id="ui.text.info.UNKNOWN_AGEGATE_STATE"
          defaultMessage="An unknown error occurred when verifying your age. Please refresh the page and try again."
          description="An error message showing up when the user gets the age gate in an unknown state." />
      );
    }
  }

  render () {
    return (
      <div className={this.props.theme.AgeGate}>
        <div>
          <img className={this.props.theme.Logo} src={this.props.logo} />
        </div>

        {this.props.regionPicker}
        {this.innerComponent()}
      </div>
    );
  }
}

AgeGate.propTypes = {
  onDisable: PropTypes.func,
  logo: PropTypes.string,
  regionPicker: PropTypes.node,
  selectedDay: PropTypes.number,
  selectedMonth: PropTypes.number,
  selectedYear: PropTypes.number,
  submitLabel: PropTypes.string,
  prompt: PropTypes.string,
};

themeable(AgeGate, {
  classes: [
    'AgeGate',
    'Logo',
  ],
  forwards: [
    AgeGateForm,
    AgeGateLockout,
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-agegate/components/AgeGate.jsx